import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function DualCTA() {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.1
  });
  return <section id="demo" className="py-24 bg-gradient-to-br from-indigo-600 to-cyan-500 relative overflow-hidden" data-id="element-9">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-10">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-white/10 blur-[80px]" data-id="element-11"></div>
        <div className="absolute -bottom-[20%] -left-[10%] w-[60%] h-[60%] rounded-full bg-indigo-900/20 blur-[80px]" data-id="element-12"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" ref={ref} data-id="element-13">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-14">
          {/* Left Card - Wishlist */}
          <div className={`bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 md:p-10 flex flex-col ${isVisible ? 'animate-fade-in-up delay-100' : 'opacity-0'}`} data-id="element-15">
            <span className="text-white/60 text-sm uppercase tracking-wider font-semibold mb-4" data-id="element-16">
              For early adopters
            </span>
            <h2 className="text-white text-3xl md:text-4xl font-bold mb-4" data-id="element-17">
              Join the Wishlist
            </h2>
            <p className="text-white/80 text-lg mb-8 leading-relaxed flex-grow" data-id="element-18">
              Be among the first to access Workium AI. We'll notify you at
              launch and give early users priority onboarding.
            </p>

            <form className="mt-auto" onSubmit={e => e.preventDefault()} data-id="element-19">
              <div className="flex flex-col gap-4" data-id="element-20">
                <input type="email" placeholder="name@company.com" className="w-full bg-white/10 border border-white/20 text-white placeholder:text-white/50 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-white/50 transition-all" aria-label="Email address" required data-id="element-21" />
                <button type="submit" className="w-full bg-white text-indigo-600 font-bold text-lg rounded-xl px-4 py-3 hover:bg-slate-100 transition-colors shadow-lg" data-id="element-22">
                  Get Early Access
                </button>
                <p className="text-white/60 text-sm text-center mt-2" data-id="element-23">
                  ✓ No spam. Unsubscribe anytime.
                </p>
              </div>
            </form>
          </div>

          {/* Right Card - Demo */}
          <div className={`bg-white/5 backdrop-blur-sm border border-white/20 rounded-2xl p-8 md:p-10 flex flex-col ${isVisible ? 'animate-fade-in-up delay-300' : 'opacity-0'}`} data-id="element-24">
            <span className="text-white/60 text-sm uppercase tracking-wider font-semibold mb-4" data-id="element-25">
              For decision makers
            </span>
            <h2 className="text-white text-3xl md:text-4xl font-bold mb-4" data-id="element-26">
              Request a Demo
            </h2>
            <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-27">
              See Workium AI connected to your real tools. We'll show you
              exactly how it works for your team's workflow.
            </p>

            <div className="space-y-4 mb-8 flex-grow" data-id="element-28">
              <div className="flex items-center gap-3 text-white" data-id="element-29">
                <div className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0" data-id="element-30">
                  ✓
                </div>
                <span data-id="element-31">30-minute live walkthrough</span>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-32">
                <div className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0" data-id="element-33">
                  ✓
                </div>
                <span data-id="element-34">Connected to your actual Jira/Slack</span>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-35">
                <div className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0" data-id="element-36">
                  ✓
                </div>
                <span data-id="element-37">No sales pressure</span>
              </div>
            </div>

            <button className="w-full bg-transparent border-2 border-white text-white font-bold text-lg rounded-xl px-4 py-3 hover:bg-white/10 transition-colors mt-auto" data-id="element-38">
              Schedule My Demo →
            </button>
          </div>
        </div>
      </div>
    </section>;
}